import {defaultIO, DefaultIO} from "../DefaultIO";
import {UserValueObject} from "../../model/vo/user/UserValueObject";

export const UserIO: DefaultIO<UserValueObject> = defaultIO(
    '/api/v3/users',
    UserValueObject.construct
)